<template>
	<div style="margin-top: 0px;">

		<!-- 3.使用组件 -->
		<!-- 页头 -->
		<roheader></roheader>
		<!-- 内容 -->

		<div style="width:100%;background: #F1F1F1;overflow: auto;padding-bottom: 30px;">
			<div style="width:1200px;margin:auto;padding:20px;">
				<rosidebar :selected_page="selected_page"></rosidebar>
				<div
					style="float: right;width:calc(100% - 269px);overflow: auto;height:1090px;background: white;border-radius: 5px;">
					<h6 style="border-bottom: 1px solid #F1F1F1;line-height: 70px;text-align: left;padding-left: 20px;">
						<!-- 您的位置： -->
						<!-- <span style="color:gray;">首页</span> > <span style="color:gray;">个人中心</span> > -->
						<span style="color:#07ccec;">账户信息</span>
					</h6>

					<el-form label-width="150px" class="demo-ruleForm" style="padding:20px;">

						<div style="overflow: hidden;">

							<el-form-item label="手机号" prop="">
								<el-input v-model="phone" placeholder="" disabled></el-input>
							</el-form-item>

							<el-form-item label="E-mail" prop="">
								<el-input v-model="email" placeholder="" disabled></el-input>
							</el-form-item>


						</div>


					</el-form>

					<el-form label-width="150px" class="demo-ruleForm" style="padding:20px;">
						<h6
							style="border-bottom: 1px solid #F1F1F1;line-height: 70px;text-align: left;padding-left: 20px;">
							<!-- 您的位置： -->
							<!-- <span style="color:gray;">首页</span> > <span style="color:gray;">个人中心</span> > -->
							<span style="color:#07ccec;">信息变更</span>
						</h6>
						<div style="overflow: hidden;">

						<!-- 	<el-form-item label="手机号" prop="">
								<el-input v-model="change_phone" placeholder=""></el-input>
							</el-form-item> -->

							<el-form-item label="E-mail" prop="">
								<el-input v-model="change_email" placeholder=""></el-input>
							</el-form-item>
							<el-form-item label="验证码" prop="">
								<el-input v-model='kapkey' placeholder="请输入验证码">
									<el-button :disabled="isCounting" slot="append"
										@click="send_message">{{ buttonText }}</el-button>
								</el-input>
							</el-form-item>
							<!-- <el-form-item label="重置密码" prop="">
								<el-input v-model="password" placeholder=""></el-input>
							</el-form-item>
							<el-form-item label="确认重置密码" prop="">
								<el-input v-model="confirm_password" placeholder=""></el-input>
							</el-form-item> -->


						</div>
						<el-button size="small" style="float: right;margin-top: 8px;background-color: red;color:white;"
							@click="confirm_reset_user_info()">确认修改</el-button>

					</el-form>





				</div>

			</div>
		</div>
		<!-- 页脚 -->
		<rofooter></rofooter>
	</div>

</template>



<script>
	import {
		fetchGet,
		fetchPost
	} from "../utils/request"
	import qs from 'qs'
	// 1.导入组件
	import roheader from "./components/ro_header.vue";
	import rofooter from "./components/ro_footer.vue";
	import rosidebar from "./components/ro_sidebar.vue";
	export default {
		name: 'user_infor',
		data() {
			return {
				confirm_password: '',
				phone: '',
				email: '',
				change_phone: '',
				change_email: '',
				password: '',
				kapkey: '',
				isCounting: false,
				countdown: 60,
				selected_page: '1-2',
			}
		},
		computed: {
			buttonText() {
				return this.isCounting ? `${this.countdown}秒后重试` : '点击发送'
			},
			passwordsMatch() {
				return this.password === this.confirm_password
			}

		},
		mounted() {
			this.get_home_setting()
			setTimeout(this.set_null, 1000)
		},
		components: {
			// 2.注册局部组件
			roheader,
			rofooter,
			rosidebar,

		},
		methods: {
			get_home_setting() {
				var phone = localStorage.getItem('phone')
				var email = localStorage.getItem('email')
				this.phone = phone
				this.email = email
				this.change_phone = phone
				this.change_email = email
				var self = this
				fetchPost('/ro/tec_search/settings/website/v1').then(response => {
					console.log(response.data)
					self.cscy_description = response.data.list.intro_tech
					self.cscy_url = response.data.list.tech_img

					self.kjcy_description = response.data.list.intro_reference
					self.kjcy_url = response.data.list.reference_img
					self.message_type = response.data.message_type

					self.sci_description = response.data.list.intro_sci
					self.sci_url = response.data.list.sci_img
					self.notice_url = response.data.list.notice_img
					self.notice = response.data.list.notice_list
					if (response.data.list.notice_list.length > 3) {
						self.show_find_more = true
					}
					self.term = response.data.list.term
				})
			},

			startCountdown() {
				this.isCounting = true
				this.countdownTimer = setInterval(() => {
					if (this.countdown > 0) {
						this.countdown--
					} else {
						clearInterval(this.countdownTimer)
						this.isCounting = false
						this.countdown = 60
					}
				}, 1000)
			},
			send_message() {
				var data = {
					'phone': this.phone,
					'email': this.change_email,
					'sms_type': 'verification',
					'page_type': 'forget'
				}
				var self = this
				if (this.message_type == 'sms') {
					this.$alert('请从手机【' + this.phone + '】接收验证码。', '提示', {
						confirmButtonText: '确定',
						callback: action => {
							// this.$message({
							//   type: 'info',
							//   message: ``
							// });
						}
					});
					fetchPost('/ro/connector/aliyun/send_message/v1', data).then(response => {
						// debugger

						if (response.data == 'success') {
							self.$message({
								type: 'success',
								message: '发送成功,请注意查收短信'
							});
							this.startCountdown()
						} else {
							this.$message.error('发送失败，' + response.data);
						}
					})
				} else {
					this.$alert('请从邮箱【' + this.change_email + '】接收验证码。', '提示', {
						confirmButtonText: '确定',
						callback: action => {
							// this.$message({
							//   type: 'info',
							//   message: ``
							// });
						}
					});
					fetchPost('/ro/connector/email/send_message/v1', data).then(response => {
						// debugger
						if (response.data == 'success') {
							self.$message({
								type: 'success',
								message: '发送成功,请注意查收邮箱'
							});
							this.startCountdown()
						} else {
							this.$message.error('发送失败，' + response.data);
						}
					})
				}
				// this.startCountdown()

			},

			beforeDestroy() {
				clearInterval(this.countdownTimer)
			},
			confirm_reset_user_info() {
				var data = {
					'mobile': this.phone,
					'email': this.email,
					'change_email': this.change_email,
					'change_phone': this.change_phone,

					'kapkey': this.kapkey
				}
				if (this.kapkey == '' || this.phone == ''|| this.change_email == ''|| this.change_email == 'false') {
					this.$message.error('请输入完整信息')
					return
				}
				if (this.passwordsMatch) {
					fetchPost('/ro/tec_search/user/change_user_info/v1', data).then(response => {
						if (response.data.result == 'fail') {
							this.$message.error(response.data.reason)
						} else {
							this.$alert('更新完成', '提示', {
								confirmButtonText: '确定',
								callback: action => {
									localStorage.setItem('phone', false)
									localStorage.setItem('user_id', false)
									localStorage.setItem('message_qty', false)
									localStorage.setItem('session_id', false)
									localStorage.setItem('livechat_token', false)
									this.$router.push("/pages/login")
								}
							});
						}
					})
				} else {
					this.$message.error('两次密码不一致，请重新输入')
				}

			},


		}
	}
</script>
<style>
	@import url("../static/css/css2.css");
	@import url("../static/css/app.min.css");
	@import url("../static/css/fontawesome.min.css");
	@import url("../static/css/animate.min.css");
	@import url("../static/css/style.css");

	#app {
		margin-top: 0px !important;
	}

	table {
		margin: 0 !important;
	}

	.el-table__body,
	.el-table__footer,
	.el-table__header {
		border-collapse: collapse !important;
	}

	.el-table th {
		text-align: center !important;
		background-color: #F0F0F0;
		color: #333;
	}

	.el-table td {
		text-align: center !important;
	}
</style>
